import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const PageActionContext = createContext();

export function usePageAction() {
  const context = useContext(PageActionContext);
  if (!context) {
    throw new Error('usePageAction must be used within PageActionProvider');
  }
  return context;
}

export function PageActionProvider({ children }) {
  const [action, setAction] = useState(null);
  const [middle, setMiddle] = useState(null);
  const [titleExtra, setTitleExtra] = useState(null);

  return (
    <PageActionContext.Provider value={{ action, setAction, middle, setMiddle, titleExtra, setTitleExtra }}>
      {children}
    </PageActionContext.Provider>
  );
}

PageActionProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageActionContext;
